var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.list.length)?_c('div',{staticClass:"l-flex-grid"},_vm._l((_vm.list),function(item,index){return _c('el-tag',{key:index,staticClass:"u-ml0 u-mr2 u-mb1"},[_vm._v(" "+_vm._s(item.name)+" ")])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }